import methodsCases from './methods';
import methodsConfigCases from './methodsConfig';

export default {
  ...methodsCases,
  ...methodsConfigCases,
};
